export default "__VITE_ASSET__DAW0PzrV__"